import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import ColorButton from '@/components/ColorButton'
import DurationPicker from '@/components/DurationPicker'
import LoadingContainer from '@/components/LoadingContainer'
import SettingsAdd from '@/components/SettingsAdd'
import StudentPicker from '@/components/StudentPicker'
import SubjectPicker from '@/components/SubjectPicker'
import TransitionList from '@/components/TransitionList'

import { weekday, monthDay, longDate, shortISO } from '@/filters/date'

Vue.config.productionTip = false

// Components
Vue.component('ColorButton', ColorButton)
Vue.component('DurationPicker', DurationPicker)
Vue.component('LoadingContainer', LoadingContainer)
Vue.component('SettingsAdd', SettingsAdd)
Vue.component('StudentPicker', StudentPicker)
Vue.component('SubjectPicker', SubjectPicker)
Vue.component('TransitionList', TransitionList)

// Filters
Vue.filter('weekday', weekday)
Vue.filter('monthDay', monthDay)
Vue.filter('longDate', longDate)
Vue.filter('shortISO', shortISO)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
